import { Box } from "@mui/material"
import type { FC } from "react"

import { GoodsReceiptDetailsInfoItem } from "./GoodsReceiptDetailsInfoItem"

import { type GoodsReceipt, GoodsReceiptStatus } from "@/graphql/codegen/graphql"
import { formatDate } from "@/utils/date"

interface GoodReceiptDetailsStatusDateProps {
  goodsReceipt: GoodsReceipt
}

export const GoodReceiptDetailsStatusDate: FC<GoodReceiptDetailsStatusDateProps> = ({ goodsReceipt }) => {
  const statusToDateConfig = {
    [GoodsReceiptStatus.Incoming]: {
      label: "Created:",
      getDate: () => goodsReceipt.createdOn,
      testId: "created-on",
    },
    [GoodsReceiptStatus.SoftReceived]: {
      label: "Soft Received:",
      getDate: () => goodsReceipt.softReceivedOn,
      testId: "soft-received-on",
    },
    [GoodsReceiptStatus.PreCheckedIn]: {
      label: "Pre-Checked In:",
      getDate: () => goodsReceipt.preCheckedInOn,
      testId: "pre-checked-in-on",
    },
    [GoodsReceiptStatus.CheckedIn]: {
      label: "Checked In:",
      getDate: () => goodsReceipt.checkedInOn,
      testId: "checked-in-on",
    },
    [GoodsReceiptStatus.Stored]: {
      label: "Stored:",
      getDate: () => goodsReceipt.storedOn,
      testId: "stored-on",
    },
  }

  const config = statusToDateConfig[goodsReceipt.status || GoodsReceiptStatus.Incoming]

  return (
    <GoodsReceiptDetailsInfoItem label={config.label}>
      <Box component='span' data-testid={config.testId}>
        {formatDate(config.getDate())}
      </Box>
    </GoodsReceiptDetailsInfoItem>
  )
}
